import palette from 'theme/palette';
import typography from 'theme/typography';

export default {
  root: {
    ...typography.body1,
    borderBottom: `1px solid ${palette.divider}`
  }
};